export default __webpack_public_path__ + "static/media/hessahStore6.55229c9c.jpg";